import { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { Form, Input } from "antd";
import { SimpleInput } from "../../../../common/components/simpleInput";
import style from "../../../../common/styles/styleForm.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { useSearchParams } from "react-router";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../utilities/API_URLs";
import { DamagedZoneConstant } from "../core/_constant";
import { DamagedZoneService } from "../core/_request";
import { HttpStatusCode } from "axios";

type DamagedZoneFormType = {
  onFinish: () => void;
  initialValue?: any;
};
export const DamagedZoneForm = ({ onFinish, initialValue }: DamagedZoneFormType) => {
  const [form] = Form.useForm();

  const [searchParams] = useSearchParams();
  const loadType = searchParams.get("type");

  const [initialState] = useState<any>({
    loadType: `/api/load_types/${loadType?.toUpperCase()}`,
  });
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    form.setFieldsValue(initialState);
  }, []);

  useEffect(() => {
    // form.setFieldsValue(initialState);
    const formatInitialValue = {
        loadSubType: {
            value: initialValue?.loadSubType?.["@id"],
          },
      ...(initialValue?.id ? { id: initialValue?.id } : {}),
    code: initialValue?.code,
    nameFr: initialValue?.nameFr,
    nameEn: initialValue?.nameEn,
    ...(initialValue?.containerCategory
        ? { containerCategory: {
            value: initialValue?.containerCategory["@id"],
          } }
        : {}
    )
    };

    form?.setFieldsValue(formatInitialValue);
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const formatedData = {
        ...(values?.id ? { id: values?.id } : {}),
        ...(values?.containerCategory
          ? { containerCategory: values?.containerCategory?.value }
          : {}),
        loadType: values?.loadType,
        code: values?.code,
        nameFr: values?.nameFr,
        nameEn: values?.nameEn,
      };

      if (!values?.id) {
        // Create
        const res = await DamagedZoneService.createDamagedZone(formatedData);
        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        // Edit

        const res = await DamagedZoneService.updateDamagedZone(formatedData);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
          <SimpleInput
            Form={Form}
            label="loadType"
            name={"loadType"}
            customInput={<Input value={initialState?.loadType} />}
          />
        </div>

        <div className={style.form}>
          <div className={style.form__item_wrapper}>

            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Code"
                name={"code"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
          </div>
          {loadType?.toUpperCase() === DamagedZoneConstant.AVARIE_TYPE.container ? (
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  label="Type de conteneur"
                  name={"containerCategory"}
                  rules={[
                    {
                      required: true,
                      message: `Ce champ est requis`,
                    },
                  ]}
                  customInput={
                    <InputSelect
                      valueOption={{
                        labelKey: "name",
                        valueKey: "@id",
                      }}
                      uri={`${API_URLs.settings.containerType.getContainerCategoryForSelect}`}
                      onChange={(e) => {
                        console.log(e);
                      }}
                    />
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Zone de dommage – FR"
                name={"nameFr"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Zone de dommage – EN"
                name={"nameEn"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
